import { DeclareMethod } from '/imports/methods';

export const verifyJwt = DeclareMethod<string | null>('verifyJwt');
export const geoIp = DeclareMethod<string | void, GeoIpResult>('geoIp');

interface GeoIpName {
  en: string;
}

interface GeoIpResult {
  city: {
    geoname_id: number;
    names: GeoIpName;
  },
  continent: {
    code: string;
    geoname_id: number;
    names: GeoIpName;
  },
  country: {
    iso_code: string,
    geoname_id: number;
    names: GeoIpName;
  },
  location: {
    accuracy_radius: number;
    latitude: number;
    longitude: number;
    time_zone: string;
  },
  postal: {
    code: string;
  },
  registered_country: {
    iso_code: string,
    geoname_id: number;
    names: GeoIpName;
  },
  subdivisions: {
    iso_code: string;
    geoname_id: number;
    names: GeoIpName;
  }[],
  traits: {
    autonomous_system_number: number;
    autonomous_system_organization: string;
    connection_type: string;
    isp: string;
    organization: string;
    ip_address: string;
    network: string;
  }
}